<template>
    <SimpleTable formclass="pages/State/form" endpoint="api/v2/state" :aditionalColumns="headers">
        <template>
            <h1>Estados</h1>
            <v-divider class="mb-4" />
        </template>
    </SimpleTable>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";
export default {
    components: {
        SimpleTable,
    },
    data() {
        return {
            headers: [{ text: "Nome", value: "name", align: "right", sortable: true }],
        };
    },
};
</script>